/**
 * Helper function to normalize SSN/ITIN by removing hyphens
 * @param ssnOrItin - SSN or ITIN string that may contain hyphens
 * @returns SSN/ITIN string with hyphens removed, or null if input is falsy
 */
export const normalizeSSNOrITIN = (ssnOrItin: string): string | null => {
  if (!ssnOrItin) return null;
  return ssnOrItin.replace(/-/g, '');
};
